/*
 * Jira Ticket:
 * Created Date: Wed, 25th Mar 2020, 10:18:12 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { cloneElement, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  TopToolbar,
  sanitizeListRestProps,
  useDataProvider,
} from 'react-admin';
import { ActionButton } from 'Components/Buttons';
import { GetApp, Help } from '@material-ui/icons';
import getHelp from '../../utils/getHelp';

const InspectionActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  onClick,
  ...rest
}) => {
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();
  const [helpLink, setHelpLink] = useState();

  const useMountEffect = fun => useEffect(fun, []);
  useMountEffect(
    getHelp('help_url_inspection', { dataProvider, dispatch, setHelpLink })
  ); // run once

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {helpLink && (
        <ActionButton
          label="resources.General.help"
          variant="text"
          onClick={() => {
            window.open(helpLink);
          }}
          icon={<Help />}
        />
      )}
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <ActionButton
        label="actions.exportInspectionCSV"
        variant="text"
        onClick={() => onClick(filterValues)}
        icon={<GetApp />}
      />
    </TopToolbar>
  );
};

InspectionActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default InspectionActions;
